export default {
    NOT_UNIQUE_NAME: 'reporting.reportName.error.exists',
    NAME_IS_EMPTY: 'reporting.reportName.error.empty',
    SIDE_SPACES: 'reporting.reportName.error.spaces'
};
